import { favoriteTeams } from 'actions/user_entities_actions';
import { FavoriteGamesQuery, GenderSportEnum, LevelEnum, StateEnum } from 'queries';
import favoriteGamesQuery from 'queries/favoriteGamesQuery.js.erb';
import { useEffect, useState } from 'react';
import { useUserEntities } from 'stores/userEntitiesStore';

export default function useFavoriteGames(
  {
    date,
    genderSport,
    level,
    organizationId,
    power25,
    state
  }: {
    date?: string | null;
    genderSport?: GenderSportEnum | null;
    level?: LevelEnum | null;
    organizationId?: string | null;
    power25?: boolean | null;
    state?: StateEnum | null;
  },
  enabled = true
) {
  const { userEntities } = useUserEntities();
  const [favoriteGames, setFavoriteGames] = useState<FavoriteGamesQuery['currentUser']['favoriteGames']['nodes'][number][]>([]);

  function fetch() {
    favoriteGamesQuery({
      date,
      genderSport,
      level,
      organizationId,
      power25,
      state
    }).then(
      ({
        currentUser: {
          favoriteGames: { nodes }
        }
      }) => {
        setFavoriteGames(nodes);
      }
    );
  }

  useEffect(() => {
    // in theory we could optimize this to save previously fetched games by filters
    if (enabled && favoriteTeams(userEntities).length > 0) {
      fetch();
    } else {
      setFavoriteGames([]);
    }
  }, [date, enabled, genderSport, state, organizationId, userEntities]);

  return favoriteGames;
}
